import React from 'react';
import TextQuestion from './questionTypes/textQuestion/TextQuestion';
import ImageQuestion from './questionTypes/imageQuestion/ImageQuestion';
import FreeTextQuestion from './questionTypes/freeTextQuestion/FreeTextQuestion';
import ScaleQuestion from './questionTypes/scaleQuestion/ScaleQuestion';
import TextPollQuestion from './questionTypes/textPollQuestion/TextPollQuestion';

/**
 *
 * @type {React.NamedExoticComponent<{readonly statisticsPopup?: *, readonly calendar?: *, readonly clickAfterTextPollQuestion?: *, readonly showTextPollQuestionResult?: *, readonly statistics?: *, readonly handleAnswerSelection?: *, readonly contentColor?: *, readonly setEventSound?: *, readonly content?: *, readonly question?: *}>}
 */
const Question = React.memo(( {showFeedback, clickAfterTextPollQuestion, showTextPollQuestionResult, calendar, question, statistics, handleAnswerSelection, statisticsPopup, content, contentColor, setEventSound } ) => {
    switch ( question.type ) {
        case 'text':
            return <TextQuestion
                contentColor={ contentColor }
                question={ question }
                statistics={ statistics }
                statisticsPopup={ statisticsPopup }
                handleAnswerSelection={ handleAnswerSelection }
                setEventSound={ setEventSound }
                calendar={ calendar }
            />;
        case 'image':
            return <ImageQuestion
                question={ question }
                statistics={ statistics }
                statisticsPopup={ statisticsPopup }
                handleAnswerSelection={ handleAnswerSelection }
                contentColor={ contentColor }
                setEventSound={ setEventSound }
                calendar={ calendar }
            />;
        case 'free_text':
            return <FreeTextQuestion
                contentColor={ contentColor }
                question={ question }
                statistics={ statistics }
                statisticsPopup={ statisticsPopup }
                handleAnswerSelection={ handleAnswerSelection }
                setEventSound={ setEventSound }
                calendar={ calendar }
            />;
        case 'scale':
            return <ScaleQuestion

                contentColor={ contentColor }
                question={ question }
                statistics={ statistics }
                statisticsPopup={ statisticsPopup }
                handleAnswerSelection={ handleAnswerSelection }
                setEventSound={ setEventSound }
                calendar={ calendar }
            />;
        case 'text_poll':
            return <TextPollQuestion
                clickAfterTextPollQuestion={clickAfterTextPollQuestion}
                contentColor={ contentColor }
                question={ question }
                statistics={ statistics }
                statisticsPopup={ statisticsPopup }
                handleAnswerSelection={ handleAnswerSelection }
                setEventSound={ setEventSound }
                calendar={ calendar }
                showTextPollQuestionResult={showTextPollQuestionResult}
            />;
        default:
            return <div>{ content.unknown_question_type }</div>;
    }
});

export default Question;

